import { Component } from '@angular/core';

@Component({
  selector: 'svnl-remove-address-dialog',
  templateUrl: './remove-address-dialog.component.html',
  styleUrls: ['./remove-address-dialog.component.scss'],
})
export class RemoveAddressDialogComponent {
}
